import React from 'react';
import Participant from './Participant';

export default ({ event, participants }) => {
    return (
        <div className="event__panel">
            <div className="event__description">
                {event.participant_id
                    ? renderRegularPenalty()
                    : renderBenchPenalty()}
            </div>
            {renderPenaltyMinutes()}
            {renderNotes()}
        </div>
    );

    function renderRegularPenalty() {
        return (
            <span>
                <strong>Foul!</strong>
                {' Committed by '}
                <Participant participant={participants[event.participant_id]}/>
            </span>
        );
    }

    function renderBenchPenalty() {
        return <strong>Bench Penalty!</strong>;
    }

    function renderPenaltyMinutes() {
        if (event.penalty_seconds) {
            const minutes = event.penalty_seconds / 60;
            return <div className="event__aux">Penalised {minutes} penalty minutes</div>
        }
    }

    function renderNotes() {
        if (event.notes) {
            return <div className="event__notes">“{event.notes}”</div>;
        }
    }
};
